import { Hero } from '../components/sections/Hero';
import { Features } from '../components/sections/Features';
import { Testimonials } from '../components/sections/Testimonials';

export const Home = () => {
  return (
    <main>
      <Hero />
      <Features />
      <Testimonials />
    </main>
  );
};
